import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { HotelMenuBar } from '@lt/components';
import Container from '../Container';
import { HEADER_OFFSET } from '../../../../constants/header';

const TopMenu = (props) => {
  /* force rerender on client, issue: https://github.com/vercel/next.js/issues/7417#issuecomment-509411508 */
  const [isSSR, setIsSSR] = useState(true);

  useEffect(() => {
    setIsSSR(false);
  }, []);

  if (isSSR) {
    return <SkeletonMenuBar />;
  }

  return (
    <StyledHotelMenuBar>
      <HotelMenuBar {...props} />
    </StyledHotelMenuBar>
  );
};

const SkeletonMenuBar = styled.div`
  margin-bottom: 15px;
  min-height: 50px;
`;

const StyledHotelMenuBar = styled(Container).attrs({
  fullWidth: true,
  white: true,
})`
  position: sticky;
  z-index: 10;
  top: ${HEADER_OFFSET}px;
  margin-bottom: 15px;
  box-shadow: 1px -1px 5px 0 rgba(216, 214, 204, 0.6),
    0 1px 3px 0 rgba(210, 208, 197, 0.9);
`;

export default React.memo(TopMenu);
